import { QuestionBase } from './question-base.model';

export class NumberboxQuestion extends QuestionBase<number> {
   controlType = 'numberbox';
   visible: boolean;
   default: any;
   disabled: boolean;
   step: any;
   pattern: any;
   formAutofill: any;
   placeholder: string = '';
   min: any;
   max: any;
   fieldType: any;
   type:any = 'number';
   setDefault: boolean;
   cstm_error_msg: any;
   tooltip_key: string;
   constructor(options: {} = {}) {
      super(options);
      this.visible = (options['visible'] == undefined) ? true : options['visible'];
      this.disabled = options['disabled'] || '';
      this.pattern = options['pattern'];
      this.cstm_error_msg = options['cstm_error_msg'];
      this.value = options['value'] || 0;
      this.default = options['default'];
      this.step = options['step'];
      this.min = options['min'] == undefined ? null : options['min'];
      this.max = options['max'] == undefined ? null : options['max'];
      this.formAutofill = options['formAutofill'];
      this.fieldType = options['fieldType'] || 'integer';
      this.placeholder = options['placeholder'] || '';
      this.setDefault = options['setDefault'];
      this.tooltip_key = options['tooltip_key'] || "";
      this.type = (options['type'] && options['type'] == "decimal_currency") ? options['type'] : 'number';
   }
}